/**
 * Formats error messages for display to the user
 * @param {Object} error - The error object
 * @param {string} error.error - The error code
 * @param {string} error.message - The error message
 * @param {string} error.existingAgentId - The ID of the agent who owns the customer (if applicable)
 * @returns {string} Formatted error message
 */
export const formatErrorMessage = (error) => {
  if (!error) return 'An unknown error occurred';
  
  switch (error.error) {
    case 'CUSTOMER_CLAIMED':
      return `This customer is already managed by agent ${error.existingAgentId || 'another agent'}. ` +
             'Please verify the mobile number or contact support if you believe this is an error.';
    default:
      return error.message || 'An unexpected error occurred. Please try again.';
  }
};
